import React from 'react';
import { Col, Placeholder, Row } from 'react-bootstrap';

const PLATFORM_ICONS = 3;
const DESCRIPTION_LINES = [12, 11, 7];

export function BookingCardSkeleton() {
    return (
        <Col lg={6} className="mb-4" aria-hidden="true">
            <Row className="booking-card-skelet m-0 position-relative overflow-hidden">
                <Col md={5} className="p-0 position-relative">
                    <Placeholder as="div" animation="glow" className="h-100">
                        <Placeholder className="skeleton skeleton-booking-image" />
                    </Placeholder>
                    <Placeholder as="div" animation="glow" className="skeleton-booking-user">
                        <Placeholder className="skeleton skeleton-avatar skeleton-on-image" />
                        <div className="ml-2 flex-grow-1">
                            <Placeholder xs={8} className="skeleton skeleton-on-image d-block" />
                            <Placeholder xs={5} className="skeleton skeleton-on-image d-block mt-2" />
                        </div>
                    </Placeholder>
                </Col>

                <Col md={7} className="d-flex flex-column justify-content-between py-3">
                    <Placeholder as="div" animation="glow">
                        <div className="d-flex mb-3" style={{ gap: 8 }}>
                            {Array.from({ length: PLATFORM_ICONS }).map((_, i) => (
                                <div key={i} className="d-flex flex-column align-items-center">
                                    <Placeholder className="skeleton skeleton-icon" />
                                    <Placeholder className="skeleton skeleton-platform-label mt-1" />
                                </div>
                            ))}
                        </div>
                        {DESCRIPTION_LINES.map((width, i) => (
                            <Placeholder
                                key={i}
                                xs={width}
                                className="skeleton skeleton-description-line d-block mb-2"
                            />
                        ))}
                    </Placeholder>

                    <Placeholder
                        as="div"
                        animation="glow"
                        className="d-flex align-items-center justify-content-between mt-3"
                    >
                        <Placeholder className="skeleton skeleton-price" />
                        <div className="d-flex align-items-center">
                            <Placeholder className="skeleton skeleton-icon mr-2" />
                            <Placeholder className="skeleton skeleton-outline-btn skeleton-btn-sm" />
                        </div>
                    </Placeholder>
                </Col>
            </Row>
        </Col>
    );
}
